module.exports = __webpack_public_path__ + "static/media/email-link-clicked-white.b199e864.svg";